/* Toolkit 4: Inspection-to-Improvement Turnaround Planner. Milestones keep schools inside statutory processes. */
export const SCHOOL_TYPES = ["", "Primary", "Secondary", "All-through", "Special school", "Pupil Referral Unit / AP", "Hospital school", "Post-16 / FE", "Other"];

export const REGIONS = ["", "North East", "North West", "Yorkshire and the Humber", "East Midlands", "West Midlands", "East of England", "London", "South East", "South West"];
export const SIGNOFF = {
  6: ["", "Executive Head", "Chair of Governors", "SENDCO Lead", "DfE Advisor", "Full Governing Body"],
  12: ["", "Trust CEO", "Local Authority Rep", "Head of School", "Staff Union Rep", "Finance Committee", "External Inspector Mock"],
};
export const PROFILE = [
  ["views", "Student views", ["", "Positive", "Mixed", "Negative"]],
  ["leadership", "Leadership style", ["", "Autocratic", "Collaborative", "Distributed"]],
  ["governance", "Governance oversight", ["", "Weak", "Developing", "Robust"]],
];
export const CPD = [
  ["cpd_leadership", "Leadership development", "DfE leadership priorities: governance monitoring and middle-leader capability."],
  ["cpd_ecf", "Early Career Framework (ECF)", "Training for early career teachers, kept separate from senior and curriculum lead pathways."],
  ["cpd_safeguarding", "Safeguarding compliance", "Regular checks built into every phase of the 6- or 12-month plan."],
];

export const COUNTS = [
  ["sen", "Pupils at SEN Support"], ["ehcp", "Pupils with an EHCP"], ["semh", "Pupils with SEMH as primary need"],
  ["hnf", "High-needs (Element 3) funded places"], ["ap", "Pupils in alternative provision"], ["claims", "Funding claims awaiting a decision"],
  ["pp", "Pupil Premium (% of pupils)"], ["fsm", "Pupils eligible for free school meals"],
];

export const milestones = (track, n) => (track === "6" ? [
  ["Months 1–2: Stabilisation (safeguarding and statutory compliance)", [
    "Check the Single Central Record and safeguarding logs are complete and accurate.",
    `Audit the ${n.ehcp} EHCPs against statutory timescales (annual reviews, Section F provision in place) and agree any gaps with the local authority SEND team.`,
    "Prepare a short safeguarding and SEND compliance summary for governors."]],
  ["Months 3–4: Rapid fixes (consistent classroom practice)", [
    "Agree consistent adaptive teaching and behaviour approaches across all classes.",
    "Deliver targeted CPD matched to the school's main areas of need.",
    "Run fortnightly internal reviews to check practice is consistent."]],
  ["Months 5–6: Verification and sign-off", [
    "Gather anonymised pupil and parent views on inclusion.",
    "Report progress against each inspection finding to governors or the trust board.",
    "Agree next priorities and keep the evidence ready for the next inspection."]],
] : [
  ["Months 1–3: Discovery and audit", [
    "Check safeguarding registers, the Single Central Record and data protection arrangements.",
    `Review the ${n.ehcp} EHCPs for statutory compliance and request reviews with the local authority where provision has changed.`,
    `Reconcile high-needs funding with the local authority, including the ${n.claims} claims awaiting a decision.`]],
  ["Months 4–6: Cultural core (curriculum and workforce)", [
    "Adjust curriculum plans to address the exact gaps in the inspection findings.",
    "Set up professional development and mentoring pathways for teachers and support staff.",
    `Review the ${n.ap} alternative provision placements for registration, attendance, safeguarding and outcomes, in line with the statutory AP guidance.`]],
  ["Months 7–9: Embedding change", [
    `Link targeted support, including for the ${n.semh} pupils with SEMH needs, with the mainstream curriculum.`,
    "Strengthen governor oversight of SEND, including a named SEND link governor.",
    "Share progress with parents and carers through the SEN Information Report."]],
  ["Months 10–12: Sustained quality (evaluate and verify)", [
    "Align with the local area SEND inspection (Ofsted and CQC) priorities and the local authority's SEND strategy.",
    "Review therapy and health provision with NHS and other partners through the EHCP review process.",
    "Run a peer-led or mock review to test progress against the findings.",
    "Complete a final evaluation and set next year's priorities."]],
]);

/** Runs in the browser only. Replaces common personal identifiers with tokens; always check the result. */
export const scrub = (text) => (text || "")
  .replace(/\b[A-Z]{1,2}[0-9][A-Z0-9]?\s?[0-9][A-Z]{2}\b/gi, "[POSTCODE REMOVED]")
  .replace(/\b\d{1,2}[/.-]\d{1,2}[/.-]\d{2,4}\b/g, "[DATE REMOVED]")
  .replace(/\b[A-Z]\d{11}[A-Z0-9]\b/g, "[UPN REMOVED]")
  .replace(/\b\d+\s+[A-Z][a-z]+\s+(Street|Road|Lane|Avenue|Close|Way|Drive|Crescent|Gardens|Place)\b/g, "[ADDRESS REMOVED]")
  .replace(/\b([Cc]hild|[Ss]tudent|[Pp]upil|[Ll]earner|[Nn]ame|[Nn]amed)\s+[A-Z][a-z]+(\s+[A-Z][a-z]+)?\b/g, "$1 [NAME REMOVED]")
  .replace(/\b(Mr|Mrs|Ms|Miss|Dr)\.?\s+[A-Z][a-z]+\b/g, "$1 [NAME REMOVED]")
  .replace(/[\w.+-]+@[\w-]+\.[\w.]+/g, "[EMAIL REMOVED]");
